/* =========================================================
   ARKVEDA QUESTION FORM — SCRIPT
========================================================= */
(function(){
  'use strict';

  function initQuesForm(section){
    if(!section || section.dataset.arkQuesInit === 'true') return;
    section.dataset.arkQuesInit = 'true';

    var form = section.querySelector('.ark-consultation-form');
    var cards = section.querySelectorAll('.ark-question-card');
    var progress = section.querySelector('.ark-progress-fill');
    var currentQuestion = section.querySelector('.ark-current-question');
    var progressPercent = section.querySelector('.ark-progress-percent');
    var emailBody = section.querySelector('.ark-email-body');
    var success = section.querySelector('.ark-success');
    var left = section.querySelector('.ark-ques-left');

    var answers = {
      'Health Concern':'',
      'Concern Duration':'',
      'Concern Severity':'',
      'Previous Treatment':'',
      'Preferred Consultation':''
    };

    var currentStep = 1;

    function showStep(step){
      currentStep = step;

      cards.forEach(function(card){ card.classList.remove('ark-active'); });

      var activeCard = section.querySelector('.ark-question-card[data-step="'+step+'"]');
      if(activeCard) activeCard.classList.add('ark-active');

      if(step <= 5){
        var percent = step * 20;
        if(progress) progress.style.width = percent + '%';
        if(currentQuestion) currentQuestion.textContent = step;
        if(progressPercent) progressPercent.textContent = percent + '%';
      } else {
        if(progress) progress.style.width = '100%';
        if(currentQuestion) currentQuestion.textContent = '5';
        if(progressPercent) progressPercent.textContent = '100%';
      }

      setTimeout(function(){
        if(left){
          var rect = left.getBoundingClientRect();
          if(rect.top < 0){
            window.scrollTo({
              top: window.scrollY + rect.top - 20,
              behavior: 'smooth'
            });
          }
        }
      }, 50);
    }

    /* Option click */
    section.querySelectorAll('.ark-option').forEach(function(option){
      option.addEventListener('click', function(){
        var card = option.closest('.ark-question-card');
        if(!card) return;

        card.querySelectorAll('.ark-option').forEach(function(item){
          item.classList.remove('selected');
        });
        option.classList.add('selected');

        var question = option.getAttribute('data-question');
        var value = option.getAttribute('data-value');
        if(question) answers[question] = value || '';

        var next = card.querySelector('.ark-next');
        if(next) next.disabled = false;

        var step = Number(card.getAttribute('data-step'));
        if(step < 5){
          setTimeout(function(){ showStep(step + 1); }, 250);
        }
      });
    });

    /* Next */
    section.querySelectorAll('.ark-next').forEach(function(button){
      button.addEventListener('click', function(){
        if(button.disabled) return;
        if(currentStep < 6) showStep(currentStep + 1);
      });
    });

    /* Back */
    section.querySelectorAll('.ark-back').forEach(function(button){
      button.addEventListener('click', function(){
        if(currentStep > 1) showStep(currentStep - 1);
      });
    });

    /* Build email body */
    function createEmailBody(){
      var name = section.querySelector('.ark-name').value.trim();
      var phone = section.querySelector('.ark-phone').value.trim();
      var email = section.querySelector('.ark-email').value.trim();
      var age = section.querySelector('.ark-age').value.trim();
      var message = section.querySelector('.ark-message').value.trim();

      var body = '';
      body += 'FREE DOCTOR CONSULTATION REQUEST\n';
      body += '========================================\n\n';
      body += 'PATIENT DETAILS\n';
      body += '----------------------------------------\n';
      body += 'Name: ' + name + '\n';
      body += 'Mobile: ' + phone + '\n';
      body += 'Email: ' + email + '\n';
      body += 'Age: ' + age + '\n\n';
      body += 'CONSULTATION ANSWERS\n';
      body += '----------------------------------------\n';
      body += 'Health Concern: ' + (answers['Health Concern'] || 'Not selected') + '\n';
      body += 'Concern Duration: ' + (answers['Concern Duration'] || 'Not selected') + '\n';
      body += 'Concern Severity: ' + (answers['Concern Severity'] || 'Not selected') + '\n';
      body += 'Previous Treatment: ' + (answers['Previous Treatment'] || 'Not selected') + '\n';
      body += 'Preferred Consultation: ' + (answers['Preferred Consultation'] || 'Not selected') + '\n\n';
      body += 'ADDITIONAL INFORMATION\n';
      body += '----------------------------------------\n';
      body += message || 'No additional information provided.';

      return body;
    }

    /* Submit */
    if(form){
      form.addEventListener('submit', function(event){
        var name = section.querySelector('.ark-name');
        var phone = section.querySelector('.ark-phone');
        var email = section.querySelector('.ark-email');
        var age = section.querySelector('.ark-age');

        if(!name.value.trim() || !phone.value.trim() || !email.value.trim() || !age.value.trim()){
          event.preventDefault();
          alert('Please fill in all required details.');
          return;
        }

        emailBody.value = createEmailBody();
      });
    }

    /* Success state — Liquid se pass hoga */
    if(section.dataset.arkSuccess === 'true'){
      if(form) form.style.display = 'none';

      var progressArea = section.querySelector('.ark-progress-area');
      var eyebrow = section.querySelector('.ark-ques-eyebrow');
      var title = section.querySelector('.ark-ques-title');
      var subtitle = section.querySelector('.ark-ques-subtitle');

      if(progressArea) progressArea.style.display = 'none';
      if(eyebrow) eyebrow.style.display = 'none';
      if(title) title.style.display = 'none';
      if(subtitle) subtitle.style.display = 'none';
      if(success) success.hidden = false;
    }

    showStep(1);
  }

  function initAll(){
    document.querySelectorAll('.ark-ques-section').forEach(initQuesForm);
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function(e){
    if(e.target && e.target.querySelector){
      var sec = e.target.querySelector('.ark-ques-section');
      if(sec){ sec.dataset.arkQuesInit = 'false'; initQuesForm(sec); }
    }
  });
})();